import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

import GoogleDeliveryMap from 'src/delivery/components/google-delivery-map';
import MapboxDeliveryMap from 'src/delivery/components/mapbox-delivery-map';

// ECOMM-13538: Google -> Mapbox migration, gated behind growth.ecomm.delivery-tracking-mapbox.rollout
// (default off). ECOMM-13539 removes this dispatcher + the Google branch once rolled out.
export default function GMap(props) {
  const flags = useFlags();
  const useMapbox = flags['growth.ecomm.delivery-tracking-mapbox.rollout'] === true;

  if (useMapbox) {
    return <MapboxDeliveryMap {...props} />;
  }
  return <GoogleDeliveryMap {...props} />;
}
